import { addErrorToast } from '@scouts/ui'

import { CANARIAS_ID, ERROR_MESSAGE_SAVING } from '@/constants'
import { CompanyDTO } from '@/models'

import { useUpdateTaxRegime } from '@/hooks/tax-regime'

import { useProfile } from '../profile'
import { useCreateOrUpdateCompanyMutation, useGetCompanyQuery } from './api'

export const useCompany = () => {
    const { id, isCompany } = useProfile()
    const { isLoading, isError, data } = useGetCompanyQuery({ userId: id }, { skip: !isCompany })

    return {
        isLoading,
        isError,
        company: data,
    }
}

export const useCreateOrUpdateCompany = () => {
    const { id } = useProfile()
    const [action, { isLoading }] = useCreateOrUpdateCompanyMutation()
    const { updateTaxRegime } = useUpdateTaxRegime()

    const createOrUpdateCompany = (data: CompanyDTO) => {
        return action({ ...data, userId: id }).then(async (response) => {
            if ('error' in response) addErrorToast({ body: ERROR_MESSAGE_SAVING })
            const isUpdatedAddressCanaryIslands = Boolean(data?.address?.autonomousRegionId === CANARIAS_ID)
            await updateTaxRegime(isUpdatedAddressCanaryIslands)
            return response
        })
    }

    return { createOrUpdateCompany, isLoading }
}
